import React, { useMemo } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';

interface Props {
	value?: number;
	onChange: (value: number) => void;
}

const electricityValues = Array.from({ length: 10 }, (_, i) => i + 1);

const DENTModalOverviewGeneralEndodonticElectricityButtons = ({
	value,
	onChange,
}: Props) => {
	const rows = useMemo(
		() => [
			{
				shouldHide: false,
				items: electricityValues.slice(0, 5).map(num => ({
					title: String(num),
					isSelected: value === num,
					onClick: () => onChange(num),
				})),
			},
			{
				shouldHide: false,
				items: electricityValues.slice(5, 10).map(num => ({
					title: String(num),
					isSelected: value === num,
					onClick: () => onChange(num),
				})),
			},
		],
		[value, onChange],
	);

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewGeneralEndodonticElectricityButtons;
